/// <amd-module name="Release/Landing/LandingUtils" />
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssFeatureService } from "VSS/Platform/Feature";
import { IVssPageService } from "VSS/Platform/Page";

import { DefinitionEnvironmentReference, ReleaseDefinitionEnvironment, ReleaseDefinition, Deployment, ReleaseApproval } from "Release/Client/Contracts/Release";
import { IActiveDefinitionReference, ActiveDefinitionReferenceType } from "DataProviderContracts";

export function isHostedOldUrl(pageContext: IVssPageContext): boolean {
    const vssPageData = pageContext.getService<IVssPageService>("IVssPageService").getData();
    if (vssPageData && vssPageData.isHosted && vssPageData.hostName) {
        const url = window.location.hostname; // location.hostname is the domain. For old urls, the domain will contain the host name. Do not use location.origin as it is not supported in some builds of IE
        if (!url || url.indexOf(vssPageData.hostName) >= 0) {
            return true;
        }
    }

    return false;
}

export function getEnvironmentReferences(definition: ReleaseDefinition | undefined): DefinitionEnvironmentReference[] {
    if (definition && definition.environments) {
        return definition.environments.map((env) => {
            return {
                definitionEnvironmentId: env.id,
                definitionEnvironmentName: env.name,
                releaseDefinitionId: definition.id,
                releaseDefinitionName: definition.name
            } as DefinitionEnvironmentReference;
        });
    }

    return [];
}

export function getEnvironmentCurrentReleaseMap(environments: ReleaseDefinitionEnvironment[] | undefined | null): { [key: number]: number } {
    let definitionEnvironmentCurrentReleaseMap: { [key: number]: number } = {};
    if (environments) {
        environments.forEach((env) => {
            definitionEnvironmentCurrentReleaseMap[env.id] = (env.currentRelease && env.currentRelease.id) || 0;
        });
    }

    return definitionEnvironmentCurrentReleaseMap;
}

export function getActiveDefinitionReferenceMatch(definitions: IActiveDefinitionReference[] | null, idToMatch: number): IActiveDefinitionReference | undefined {
    let definition: IActiveDefinitionReference | undefined;
    const isActiveDefinitionReference = !!definitions && definitions.some((defRef) => {
        if (defRef.id === idToMatch) {
            definition = defRef;
            return true;
        }

        return false;
    });

    return definition;
}

export function getDefinitionReferenceFromDefinition(releaseDefinition: ReleaseDefinition, definitionType?: ActiveDefinitionReferenceType, deployment?: Deployment, pendingApproval?: ReleaseApproval): IActiveDefinitionReference {
    return {
        id: releaseDefinition.id,
        name: releaseDefinition.name,
        definitionType: definitionType || ActiveDefinitionReferenceType.Unknown,
        favoriteId: "",
        lastDeployment: deployment,
        path: releaseDefinition.path,
        pendingApproval: pendingApproval,
        releasesData: null,
        deploymentsData: null
    }
}